var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkChartStyleCandles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71449 2.28571V5.71428H7.42878V2.28571H5.71449ZM5.42878 1.71428H7.71449C7.79027 1.71428 7.86294 1.74438 7.91653 1.79796C7.97011 1.85154 8.00021 1.92422 8.00021 1.99999V5.99999C8.00021 6.07577 7.97011 6.14844 7.91653 6.20202C7.86294 6.25561 7.79027 6.28571 7.71449 6.28571H5.42878C5.353 6.28571 5.28033 6.25561 5.22675 6.20202C5.17317 6.14844 5.14307 6.07577 5.14307 5.99999V1.99999C5.14307 1.92422 5.17317 1.85154 5.22675 1.79796C5.28033 1.74438 5.353 1.71428 5.42878 1.71428Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28557 0H6.857V2H6.28557V0ZM6.28557 6H6.857V8H6.28557V6ZM1.14272 0.571429V7.42857H2.857V0.571429H1.14272ZM0.857003 0H3.14272C3.21849 0 3.29117 0.030102 3.34475 0.0836838C3.39833 0.137266 3.42843 0.209938 3.42843 0.285714V7.71429C3.42843 7.79006 3.39833 7.86273 3.34475 7.91632C3.29117 7.9699 3.21849 8 3.14272 8H0.857003C0.781227 8 0.708554 7.9699 0.654973 7.91632C0.601391 7.86273 0.571289 7.79006 0.571289 7.71429V0.285714C0.571289 0.209938 0.601391 0.137266 0.654973 0.0836838C0.708554 0.030102 0.781227 0 0.857003 0Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkChartStyleCandles);
export default __webpack_public_path__ + "static/media/dark-chart-style-candles.9fbea58a1afb2656562f6515e43ee1c9.svg";
export { ForwardRef as ReactComponent };